import React, { useState } from 'react';

/**
 * Image with a graceful failure mode.
 *
 * A missing or renamed file on the backend used to render the browser's
 * broken-image glyph inside an otherwise finished card. Here the element is
 * swapped for a neutral tinted placeholder that keeps the layout intact.
 */
const SmartImage = ({ src, alt = '', className = '', ...rest }) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <span
        className={`ij-img-fallback ${className}`.trim()}
        role="img"
        aria-label={alt || 'Image unavailable'}
      >
        <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true">
          <path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
        </svg>
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      {...rest}
    />
  );
};

export default SmartImage;
